

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useReducer, useMemo } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// The Template Dashboard 2 MUI main context
const Template = createContext(null);

// Setting custom name for the context which is visible on react dev tools
Template.displayName = "TemplateContext";

// Template Dashboard 2 MUI reducer
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "DARK_SIDENAV": {
      return { ...state, darkSidenav: action.value };
    }
    case "SIDENAV_COLOR": {
      return { ...state, sidenavColor: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "DARK_MODE": {
      return { ...state, darkMode: action.value };
    }
    case "IS_EXPORTING":{
      return {...state, isExporting:action.value}
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// Template Dashboard 2 MUI context provider
function TemplateControllerProvider({ children }) {
  const initialState = {
    miniSidenav: true, //settato a true impedisce l'apertura della sidenav all'avvio dell'app
    darkSidenav: true,
    sidenavColor: null,
    transparentNavbar: true,
    fixedNavbar: false,
    direction: "ltr",
    layout: "dashboard",
    darkMode: localStorage.getItem("darkMode")==="false",
    isExporting:false
  };

  const [controller, dispatch] = useReducer(reducer, initialState);
  
  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <Template.Provider value={value}>{children}</Template.Provider>;
}

// Template Dashboard 2 MUI custom hook for using context
function useTemplateController() {
  const context = useContext(Template);

  if (!context) {
    throw new Error("useTemplateController should be used inside the TemplateControllerProvider.");
  }

  return context;
}

// Typechecking props for the TemplateControllerProvider
TemplateControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setDarkSidenav = (dispatch, value) => dispatch({ type: "DARK_SIDENAV", value });
const setSidenavColor = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setDarkMode = (dispatch, value) => dispatch({ type: "DARK_MODE", value });
const setIsExporting=(dispatch, value)=>dispatch({type: "IS_EXPORTING", value})

export {
  TemplateControllerProvider,
  useTemplateController,
  setMiniSidenav,
  setDarkSidenav,
  setSidenavColor,
  setTransparentNavbar,
  setFixedNavbar,
  setDirection,
  setLayout,
  setDarkMode,
  setIsExporting
};
